import React from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import RegisterForm from './RegisterForm'
import { registerStart } from '../../redux/modules/user'
import { Article, Card } from '../common/Layout'
import {
  LocationBuilding,
  Location,
  LocationContainer
} from '../common/Location'

const RegisterFormContainer = reduxForm({ form: 'register' })(RegisterForm)

const Register = ({
  registerError,
  resetError,
  registerStart,
  address,
  buildingName
}) => {
  return (
    <Article>
      <Card>
        <div className="row">
          <div className="col-xs-12 center-xs">
            <h1 className="title">Register</h1>
          </div>
        </div>
        <div className="row center-xs">
          <Location>
            <LocationContainer>
              <LocationBuilding address={address} name={buildingName} />
            </LocationContainer>
          </Location>
        </div>
        <div className="row center-xs">
          <div className="col-xs-12">
            <RegisterFormContainer onSubmit={registerStart} />
          </div>
        </div>
        {registerError && (
          <div className="error">
            <p className="cart-error">{registerError.response.data.message}</p>
          </div>
        )}
      </Card>
    </Article>
  )
}

const mapStateToProps = state => {
  const { submitting, registerError } = state.user

  // MOCK DATA
  const address = {
    street: '123 Dragonberry Way',
    city: 'Hogsmeade',
    state: 'Ethelbra',
    zip: 34435
  }
  const buildingName = 'The Three Broomsticks'
  // END MOCK DATA

  return {
    submitting,
    registerError,
    address,
    buildingName
  }
}

const mapDispatchToProps = {
  registerStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register)
